import { Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { RouterStateSnapshot, TitleStrategy } from "@angular/router";

@Injectable({
	providedIn: "root",
})
export class TitleService extends TitleStrategy {
	constructor(private readonly title: Title) {
		super();
	}

	override updateTitle(routerState: RouterStateSnapshot) {
		const routeTitle = this.buildTitle(routerState);
		this.title.setTitle(
			routeTitle
				? `${routeTitle} | Qcells Energy Services`
				: "Qcells Energy Services",
		);
	}
}
